import { Reveal, SectionHeader } from "./Reveal";
import { WHY } from "../data/site";

const WhySmipl = () => (
  <section id="why" data-testid="why-section" className="relative py-28 md:py-40 bg-navy-dark/40">
    <div className="max-w-6xl mx-auto px-6">
      <SectionHeader
        index={4}
        overline="Why SMIPL"
        title={<>Built Around<br /><span className="text-smipl-orange">How We Work.</span></>}
        sub="Not claims — working principles. Eight commitments that shape every engagement we take on."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {WHY.map((w, i) => (
          <Reveal key={w.title} delay={(i % 4) * 0.07}>
            <div
              data-testid={`why-card-${i + 1}`}
              className="tracing-border group h-full rounded-2xl border border-white/8 bg-navy-deep/60 p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-smipl-orange/40"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-smipl-orange/10 border border-smipl-orange/25 text-smipl-orange group-hover:bg-smipl-orange group-hover:text-white transition-all duration-300">
                <w.icon size={19} />
              </div>
              <p className="mt-5 font-mono text-[10px] tracking-[0.3em] text-slate-600">{String(i + 1).padStart(2, "0")}</p>
              <h3 className="mt-1.5 font-display text-lg font-bold">{w.title}</h3>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">{w.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhySmipl;
